module.exports = __webpack_public_path__ + "assets/img/rank5.5143c981.png";